export enum Granularity {
  Daily,
  Hourly,
  Monthly
}